import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const TherapyContext = React.createContext();

export const useTherapyContext = () => useContext(TherapyContext);

export function TherapyProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/7c39db51-0b40-4e0d-88d3-11ef7cffa918').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/c5e0a192-ffc9-42b9-9007-92246d46c4cb')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/aa16c95b-16ce-4f85-95d7-26b239a588c8').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, articles, videos]
  );

  return <TherapyContext.Provider value={value}>{children}</TherapyContext.Provider>;
}
